import { CookieStorage } from "cookie-storage";

enum CookiesKeys {
  TokenKey = "tokenKey",
  Id = "Id",
  User = "User",
  Tenant = "Tenant",
  Modules = "Modules",
  Rol = "Rol",
  MainModules = "MainModules",
  TurnSelection = "TurnSelection",
  PreInvoiceModalCount = "PreInvoiceModalCount",
  Status = "Status",
  PatientDni = "PatientDni",
  PatientSolicitudeCode = "PatientSolicitudeCode",
  fluttertoken= "flutter.token",
  ActivePortalSession = "ActivePortalSession"

}

const getCookieDomain = () => {
  const domain = process.env.REACT_APP_DOMAIN_COOKIE?.trim();
  return domain || undefined;
};

const cookieDomain = getCookieDomain();

export const cookieStorage = new CookieStorage({
  ...(cookieDomain ? { domain: cookieDomain } : {}),
  path: "/"
});

export const cookieAvailable = (cookieKey: string, cookieValue: string) => {
  return cookieStorage.getItem(cookieKey) === cookieValue;
};

export default CookiesKeys;

const domains = [
  ...(cookieDomain ? [cookieDomain, `.${cookieDomain}`] : []),
  ".thebluecoding.com",
   "thebluecoding.com",
  "portal.thebluecoding.com"
];

export const forceRemoveAllCookies = () => {
  Object.values(CookiesKeys).forEach((key) => {
    domains.forEach((domain) => {
      try {
        const storage = new CookieStorage({
          domain,
          path: "/"
        });

        storage.removeItem(key);
      } catch (e) {
        console.log(`Error eliminando ${key} en ${domain}`);
      }
    });
  });

  // fallback adicional
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });

  localStorage.clear();
  sessionStorage.clear();
};
